(function () {
  // ── Content strings (loaded from locale via config) ───────────────────

  let LABELS = {
    dateTimeHeading: 'DATE & TIME',
    timePrefix: 'at',
    locationHeading: 'LOCATION',
    dateFallback: '--',
    timeFallback: '',
    additionalInfoHeading: 'ADDITIONAL INFORMATION',
  };

  // Only run when eventId is in the URL
  const params = new URLSearchParams(window.location.search);
  const eventId = params.get('eventId');

  if (!eventId) {
    revealSections();
    return;
  }

  // Read API config from embedded JSON
  const configEl = document.querySelector('script[data-event-config]');

  if (!configEl) {
    revealSections();
    return;
  }

  let config;

  try {
    config = JSON.parse(configEl.textContent);
    // Remove config from DOM
    configEl.remove();
  } catch (e) {
    console.error('[EventArticle] Invalid config JSON', e);
    revealSections();
    return;
  }

  // Override default labels with locale strings from config
  if (config.labels) {
    LABELS = { ...LABELS, ...config.labels };
  }

  const apiBase = (config.apiBase || '').replace(/\/$/, '');
  const token = config.token || '';

  if (!apiBase || !token) {
    revealSections();
    return;
  }

  // Fetch event data from API

  const url = `${apiBase}/api/event/${encodeURIComponent(eventId)}`;

  fetch(url, {
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  })
    .then(function (res) {
      if (!res.ok) throw new Error(`HTTP ${res.status}`);

      return res.json();
    })
    .then(function (data) {
      const event = data || {};

      if (!event) {
        revealSections();
        return;
      }

      populateHero(event);
      populateInfo(event);
      populateCallout(event);
      populateDescription(event);

      revealSections();
    })
    .catch(function (err) {
      console.error('[EventArticle] Fetch failed', err);
      revealSections();
    });

  // Reveal sections after content is ready

  function revealSections() {
    const hideStyle = document.getElementById('event-loading-hide');
    const spinner = document.getElementById('event-loading-spinner');

    // Make elements visible
    document.querySelectorAll('[data-event]').forEach((el) => {
      el.style.opacity = '1';
    });

    // Remove spinner
    if (spinner) spinner.remove();

    // Remove the hiding stylesheet after transitions finish
    if (hideStyle) {
      setTimeout(function () {
        hideStyle.remove();
      }, 350);
    }
  }

  // ── Section populators ─────────────────────────────────────────────────

  function populateHero(ev) {
    // Title
    const titleEl = document.querySelector('[data-event="title"]');

    if (titleEl && ev.name) {
      titleEl.textContent = ev.name;
    }

    // Author — hide on event pages
    const authorEl = document.querySelector('[data-event="author"]');

    if (authorEl) {
      authorEl.hidden = true;
    }

    // Image
    const imageWrap = document.querySelector('[data-event="image"]');

    if (imageWrap && ev.imageUrl) {
      imageWrap.classList.remove('hidden');

      const img = imageWrap.querySelector('img');

      if (img) {
        img.src = ev.imageUrl;
        img.srcset = '';
        img.alt = ev.name || '';
      } else {
        imageWrap.innerHTML = `<img src="${escapeAttr(ev.imageUrl)}" alt="${escapeAttr(ev.name || '')}" loading="eager" width="1120" height="500" style="width:100%;height:auto;object-fit:cover;">`;
      }
    }
  }

  function populateInfo(ev) {
    const date = formatDate(ev.dateOccurs);
    const hasDate = Boolean(ev.dateOccurs);
    const hasLocation = Boolean(ev.label || (ev.location && (ev.location.street || ev.location.city)));
    const hasCoords = Boolean(ev.latitude && ev.longitude);

    // Info content — date/time + location
    const infoEl = document.querySelector('[data-event="info-content"]');
    const mapEl = document.querySelector('[data-event="map-container"]');

    // If no date and no location, hide the entire section
    if (!hasDate && !hasLocation) {
      if (infoEl) {
        const section = infoEl.closest('section');
        if (section) section.classList.add('hidden');
      }
      return;
    }

    if (infoEl) {
      let html = '';

      // Date & Time
      if (hasDate) {
        html += `<h3>${LABELS.dateTimeHeading}</h3>`;
        html += `<p>${escapeHtml(date.full)}<br/>${LABELS.timePrefix} ${escapeHtml(date.time)}</p>`;
      }

      // Location
      if (hasLocation) {
        html += `<h3>${LABELS.locationHeading}</h3><p>`;
        if (ev.label) html += `${escapeHtml(ev.label)}<br/>`;

        const loc = ev.location;

        if (loc) {
          if (loc.street) html += `${escapeHtml(loc.street)}<br/>`;
          let cityLine = [loc.city, loc.state].filter(Boolean).join(' ');
          if (loc.postalCode) cityLine += `, ${loc.postalCode}`;
          if (cityLine) html += escapeHtml(cityLine);
        }

        html += '</p>';
      }

      // Directions button — only if coordinates exist
      const dirBtn = infoEl.querySelector('[data-event="directions-link"]');

      if (dirBtn && hasCoords) {
        html += dirBtn.outerHTML;
      }

      infoEl.innerHTML = html;
    }

    // Map iframe — only if coordinates exist
    if (mapEl) {
      if (hasCoords) {
        const coords = `${ev.latitude},${ev.longitude}`;
        const mapSrc = `https://maps.google.com/maps?q=${encodeURIComponent(coords)}&z=15&output=embed`;

        mapEl.innerHTML = `<iframe src="${escapeAttr(mapSrc)}" width="100%" height="100%" style="border:0;min-height:400px;" allowfullscreen loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>`;
      } else {
        mapEl.classList.add('hidden');
      }
    }

    // Directions link
    const dirLink = document.querySelector('[data-event="directions-link"]');

    if (dirLink) {
      if (hasCoords) {
        dirLink.href = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(`${ev.latitude},${ev.longitude}`)}`;
      } else {
        dirLink.classList.add('hidden');
      }
    }
  }

  function populateCallout(ev) {
    const regLink = document.querySelector('[data-event="register-url"]');

    if (!regLink) return;

    if (ev.registrationUrl) {
      regLink.href = ev.registrationUrl;
    } else {
      // Hide the entire callout section
      const section = regLink.closest('section');
      if (section) section.classList.add('hidden');
    }
  }

  function populateDescription(ev) {
    const descEl = document.querySelector('[data-event="description"]');

    if (!descEl || !ev.description) return;

    const doc = new DOMParser().parseFromString(ev.description, 'text/html');

    descEl.innerHTML = `<h3>${LABELS.additionalInfoHeading}</h3>`;

    while (doc.body.firstChild) {
      descEl.appendChild(doc.body.firstChild);
    }
  }

  // ── Helpers ────────────────────────────────────────────────────────────

  function formatDate(isoString) {
    try {
      const naive = isoString.replace(/Z$/, '').replace(/[+-]\d{2}:\d{2}$/, '').replace(/\.\d+$/, '');
      const d = new Date(naive + 'Z');
      const tz = 'UTC';

      let full = d
        .toLocaleString('en-US', {
          timeZone: tz,
          month: 'long',
          day: 'numeric',
          year: 'numeric',
        })
        .toUpperCase();

      // Add ordinal suffix
      const dayNum = d.toLocaleString('en-US', {
        timeZone: tz,
        day: 'numeric',
      });
      const ordinal = getOrdinal(parseInt(dayNum, 10));
      full = full.replace(dayNum, `${dayNum}${ordinal}`);

      const time = d.toLocaleString('en-US', {
        timeZone: tz,
        hour: 'numeric',
        minute: '2-digit',
        hour12: true,
      });

      return { full, time };
    } catch (e) {
      return { full: LABELS.dateFallback, time: LABELS.timeFallback };
    }
  }

  function getOrdinal(n) {
    const s = ['TH', 'ST', 'ND', 'RD'];
    const v = n % 100;
    return s[(v - 20) % 10] || s[v] || s[0];
  }

  function escapeHtml(str) {
    if (!str) return '';
    return str
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function escapeAttr(str) {
    if (!str) return '';
    return str
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }
})();
